class InfinitePageLoader extends HTMLElement {
  constructor() {
    super();

    this.sectionID = this.dataset.section || document.querySelector('infinite-page-loader')?.dataset.section || ''
    this.collectionInnerElement = document.querySelector('#CollectionLoop')
    this.saveScrollPoint();
    this.restoreScrollPoint();
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.addObserver();
  }

  addObserver() {
    const observer = new window.IntersectionObserver(([entry]) => {

      if (entry.isIntersecting) {
        if (entry.target == this.loadActivatorElem)
          observer.disconnect();

        var nextPageUrl = this.getNextPageUrl()

        if (nextPageUrl)
          this.loadProducts(nextPageUrl)
      }

    }, {
      root: null,
      threshold: 0.1
    })

    observer.observe(this)
  }

  getNextPageUrl() {
    var currentPhase = this.dataset.phase || 'available';
    var nextPage = parseInt(this.dataset.currentpage) + 1;
    var totalPages = parseInt(this.dataset.totalpages);
    var soldoutPages = parseInt(this.dataset.soldoutPages || 0);

    if (nextPage <= totalPages) {
      return this.constructURLWithSearchParams(nextPage, currentPhase)
    }

    // Phase 1 exhausted — transition to phase 2 if sold-out products exist
    if (currentPhase === 'available' && soldoutPages > 0) {
      this.dataset.phase = 'soldout';
      this.dataset.totalpages = soldoutPages;
      this.dataset.currentpage = 0;
      return this.constructURLWithSearchParams(1, 'soldout')
    }

    return false
  }

  constructURLWithSearchParams(page, phase) {
    var params = new URLSearchParams(document.location.search)
    var nextPage = parseInt(page) || parseInt(this.dataset.currentpage) + 1;
    var pageParam = this.dataset.pageParam || 'page'

    params.set(pageParam, nextPage)

    if (phase === 'soldout') {
      params.set('filter.v.availability', '0')
    } else if (phase === 'available') {
      params.set('filter.v.availability', '1')
    }

    var searchParamsAsString = params.toString()

    return "".concat(window.location.pathname, "?").concat(searchParamsAsString)
  }

  updateCurrentURL(url) {
    if (history.replaceState) {
      window.history.pushState({
        path: url
      }, '', url);
    }
  }

  loadProducts(url) {
    if (this.classList.contains('loading')) return;

    this.classList.add('loading')
    this.querySelector('div').classList.remove('hidden')

    this.getAndInsertHtml(url, 'append')
  }

  getAndInsertHtml(url, insertPosition) {
    var _this4 = this;

    if (this.abortController) {
      this.abortController.abort();
    }
    var currentUrl = new URL(url, window.location.href);
    currentUrl.searchParams.set('section_id', this.sectionID);

    try {
      this.abortController = new AbortController();

      fetch(currentUrl.toString(), {
        signal: this.abortController.signal
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = new DOMParser().parseFromString(content, "text/html");

          if (insertPosition == 'append') {
            //Appending new sets of product cards
            _this4.collectionInnerElement.insertAdjacentHTML('beforeend', tempElement.querySelector('#CollectionLoop').innerHTML);
            var responseLoader = tempElement.querySelector('infinite-page-loader');
            _this4.dataset.currentpage = responseLoader.dataset.currentpage
            _this4.dataset.totalpages = responseLoader.dataset.totalpages
            if (responseLoader.dataset.phase) {
              _this4.dataset.phase = responseLoader.dataset.phase
            }
            }
          else if (insertPosition == 'prepend') {
            _this4.collectionInnerElement.insertAdjacentHTML('afterbegin', tempElement.querySelector('#CollectionLoop').innerHTML);
            _this4.dataset.currentpage = tempElement.querySelector('load-previous-page').dataset.currentpage
          }

          _this4.init();
          _this4.saveScrollPoint();

          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

          _this4.classList.remove('loading')
          _this4.querySelector('div').classList.add('hidden')
        });
      });
    } catch (exception) { }
  }

  saveScrollPoint() {
    let productCards = document.querySelectorAll("marmeto-product-card");

    productCards.forEach((productCard) => {
      const observer = new IntersectionObserver((entries) => {
        observerCallback(entries, observer, productCard)
      },
        { threshold: 0.7 });
      observer.observe(productCard); // Observing each product card that is visible

      productCard.addEventListener('click', () => {
        sessionStorage.setItem("lastElementId", productCard.id);
      });
    })

    const observerCallback = (entries, observer, header) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting && entry.target.dataset.page) {
          this.updateCurrentURL(this.constructURLWithSearchParams(entry.target.dataset.page)) //updating the url depending on the product viewed
        }
      });
    };
  }

  reorderUnavailableProductsToEnd() {
    const container = this.collectionInnerElement;
    if (!container) return;

    const unavailableProducts = Array.from(
      container.querySelectorAll('.product-item.product-unavailable')
    );

    unavailableProducts.forEach(product => {
      container.appendChild(product);
    });
  }

  restoreScrollPoint() {
    // Returning if browser is safari as it gets scrolled to top after scrollIntoView method is used.
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) return;

    history.scrollRestoration = "manual";
    // Reverting back to the previous element that was being viewed. 
    window.onload = function () {
      var lastElementId = sessionStorage.getItem("lastElementId");
      var lastElement = document.getElementById(lastElementId);

      if (lastElement)
        lastElement.scrollIntoView();

      sessionStorage.removeItem('lastElementId');
    };
  }
}

customElements.define('infinite-page-loader', InfinitePageLoader);